module.exports = __webpack_public_path__ + "img/line-horizontal.40bc3be3.svg";